// extracted by mini-css-extract-plugin
export default {"markDown":"blog_markDown__OMmCP"};